/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ActivityContextLink } from './ActivityContextLink';
import {
    ActivityContextLinkFromJSON,
    ActivityContextLinkFromJSONTyped,
    ActivityContextLinkToJSON,
    ActivityContextLinkToJSONTyped,
} from './ActivityContextLink';

/**
 * 
 * @export
 * @interface ActorActivityRecord
 */
export interface ActorActivityRecord {
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    fieldName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    oldValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    newValue: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ActorActivityRecord
     */
    changedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    changedBy: string;
    /**
     * 
     * @type {ActivityContextLink}
     * @memberof ActorActivityRecord
     */
    subject: ActivityContextLink | null;
    /**
     * 
     * @type {ActivityContextLink}
     * @memberof ActorActivityRecord
     */
    place: ActivityContextLink | null;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    actorRole: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ActorActivityRecord
     */
    actorUserId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    actorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActorActivityRecord
     */
    note?: string | null;
}

/**
 * Check if a given object implements the ActorActivityRecord interface.
 */
export function instanceOfActorActivityRecord(value: object): value is ActorActivityRecord {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('fieldName' in value) || value['fieldName'] === undefined) return false;
    if (!('oldValue' in value) || value['oldValue'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    if (!('changedAt' in value) || value['changedAt'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('actorRole' in value) || value['actorRole'] === undefined) return false;
    return true;
}

export function ActorActivityRecordFromJSON(json: any): ActorActivityRecord {
    return ActorActivityRecordFromJSONTyped(json, false);
}

export function ActorActivityRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorActivityRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityName': json['entityName'],
        'entityId': json['entityId'],
        'action': json['action'],
        'fieldName': json['fieldName'],
        'oldValue': json['oldValue'],
        'newValue': json['newValue'],
        'changedAt': (new Date(json['changedAt'])),
        'changedBy': json['changedBy'],
        'subject': ActivityContextLinkFromJSON(json['subject']),
        'place': ActivityContextLinkFromJSON(json['place']),
        'actorRole': json['actorRole'],
        'actorUserId': json['actorUserId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['actorUserId']),
        'actorName': json['actorName'] == null ? undefined : json['actorName'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function ActorActivityRecordToJSON(json: any): ActorActivityRecord {
    return ActorActivityRecordToJSONTyped(json, false);
}

export function ActorActivityRecordToJSONTyped(value?: ActorActivityRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityName': value['entityName'],
        'entityId': value['entityId'],
        'action': value['action'],
        'fieldName': value['fieldName'],
        'oldValue': value['oldValue'],
        'newValue': value['newValue'],
        'changedAt': value['changedAt'].toISOString(),
        'changedBy': value['changedBy'],
        'subject': ActivityContextLinkToJSON(value['subject']),
        'place': ActivityContextLinkToJSON(value['place']),
        'actorRole': value['actorRole'],
        'actorUserId': ActorActivityRecordActorUserIdToJSON(value['actorUserId']),
        'actorName': value['actorName'],
        'note': value['note'],
    };
}

